<template>
  <div>
    <div class="section-title">
      <img class="" src="../assets/images/solution-title.png" alt="" />
    </div>
    <div class="solution-box">
      <ul class="solution-box-sd">
        <li
          @click="num = 0"
          class="hvrradialin"
          :class="{ hvrradialout: num == 0 }"
        >
          行业解决方案
        </li>
        <li
          @click="num = 1"
          class="hvrradialin"
          :class="{ hvrradialout: num == 1 }"
        >
          项目解决方案
        </li>
      </ul>
      <div class="solution-bottom">
        <div v-show="num == 0" class="solution-jjfa">
          <div
            class="solution-list animate__animated animate__fadeInUp"
            v-for="(item, index) in solutionlistleft"
            :key="index"
          >
            <img :src="item.imgUrl" alt="" />
            <div class="solution-bottom-s">
              <h3>{{ item.title }}</h3>
              <div class="solution-line"></div>
              <p>{{ item.text }}</p>
            </div>
            <!-- <div class="solution-more" @click="solutionMore(index +1)">MORE>></div> -->
          </div>
        </div>
        <div v-show="num == 1" class="solution-jjfa">
          <div
            class="solution-list animate__animated animate__fadeInUp"
            v-for="(item, index) in solutionlistright"
            :key="index"
          >
            <img :src="item.imgUrl" alt="" />
            <div class="solution-bottom-s">
              <h3>{{ item.title }}</h3>
              <div class="solution-line"></div>
              <p>{{ item.text }}</p>
            </div>
            <!-- <div class="solution-more" @click="solutionMore2(index +1)">MORE>></div> -->
          </div>
        </div>
      </div>
      
    </div>
    
  </div>
</template>

<script>

export default {
  data () {
    return {
      num: 0,
      isActive: 2,
      activeIndex: 0,
      activeIndex1: 1,
      solutionlistleft: [
        {
          title: '基于行业政策与法律法规',
          text:
            '针对行业从业人员管理的一体化解决方案，依据管理部门的统筹管理要求，设计从业人员信息化管理平台，设计从业人员职业技能考核标准... ',
          imgUrl: require('../assets/images/solution-listL1.png')
        },
        {
          title: '基于市场热点',
          text:
            '行业与行业从业人员处于社会组织自行评价阶段，特别是人社部关于职业资格清单目录清理以来，大量的行业职业资格取消，而行业用人需求...',
          imgUrl: require('../assets/images/solution-listL2.png')
        },
        {
          title: '定制化、模块化系统建设',
          text:
            '定制化行业管理解决方案是指通过与行业/企业管理部门（政府单位、行业协会、企业、院校等）深入沟通理解行业/企业管理要求、解决行业...',
          imgUrl: require('../assets/images/solution-listL3.png')
        }
      ],
      solutionlistright: [
        {
          title: '职业教育培训',
          text:
            '涵盖医食住行等多个民生领域，海量教学资源，专业教研团队，构建数字化教学平台，个性化、精准化教学。 ',
          imgUrl: require('../assets/images/solution-list1.png')
        },
        {
          title: '职业技能考评',
          text:
            '提供专业考试技术服务，支持集中考核、智慧家考、线上评审，全方面多维度评价，智能化分析，提高考试品质，优化考生体验。',
          imgUrl: require('../assets/images/solution-list2.png')
        },
        {
          title: '监管体系',
          text:
            '建立行业人员信息化管理系统，基于大数据统筹管理的顶层架构，运用前沿AI智能技术，精准分析教学指标，靶向定位薄弱层，全方位把控教学质量，实现培训、考评精细化、全过程监管。',
          imgUrl: require('../assets/images/solution-list3.png')
        }
      ],
      
    }
  },
  created () {
 
  },
  methods: {
    solutionMore(index){
      this.$router.push({
        path: '/solution',
        query: {page: index}
      })
    },
    solutionMore2(index){
      this.$router.push({
        path: '/insdustrysolution',
        query: {page: index}
      })
    }
  }
}
</script>

<style scoped>
.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.8);
}
.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1);
}
</style>



// WEBPACK FOOTER //
// src/components/solutionView.vue